/* ==========================================================================
   SERPROMAQ S.A.S. - DATOS COMPLETOS DEL CATÁLOGO DE PRODUCTOS Y SERVICIOS
   ========================================================================== */

export const CATALOG_ITEMS = [
  // --- SECCIÓN: VENTA DE EQUIPOS ---
  {
    id: 'm-2500-elec',
    category: 'venta',
    title: 'Montacargas Eléctrico Lithium 2.5 Tn',
    badgeText: 'NUEVO • LITIO',
    badgeClass: 'badge-green',
    highlightTag: '⚡ Batería Litio 80V',
    image: '/images/electric-forklift.jpg',
    availability: 'Disponible en Stock',
    specs: {
      capacidad: '2,500 kg (2.5 Tn)',
      altura: '4.80 m (Torre Triplex)',
      motor: 'Eléctrico AC Lithium 80V',
      garantia: '3 Años de Garantía Total'
    },
    features: [
      'Batería de litio de carga ultra rápida (1.5 horas al 100%)',
      'Cero emisiones de CO2 y mínimo nivel sonoro para bodegas',
      'Mástil de alta visibilidad y pantalla LCD de control inteligente',
      'Frenos regenerativos de alta eficiencia y bajo costo operativo'
    ],
    description: 'Montacargas eléctrico de última generación con tecnología de litio de alto rendimiento. Diseñado para trabajo continuo en centros de distribución, farmacéuticas y plantas de alimentos.'
  },
  {
    id: 'm-3500-glp',
    category: 'venta',
    title: 'Montacargas Combustión Dual GLP / Gasolina 3.5 Tn',
    badgeText: 'ALTO RENDIMIENTO',
    badgeClass: 'badge-combustion',
    highlightTag: '🔥 Motor Japonés K25',
    image: '/images/hero-forklift.jpg',
    availability: 'Entrega Inmediata',
    specs: {
      capacidad: '3,500 kg (3.5 Tn)',
      altura: '5.50 m con Desplazador',
      motor: 'Nissan K25 Dual GLP/Gas',
      garantia: '2 Años de Garantía'
    },
    features: [
      'Sistema de inyección dual de bajo consumo y máxima durabilidad',
      'Desplazador lateral de uñas (Side Shifter) incluido',
      'Cabina con suspensión neumática y protección FOPS/ROPS certificada',
      'Radiador sobredimensionado para trabajo pesado en climas cálidos'
    ],
    description: 'Potencia industrial garantizada para patios exteriores, bodegas y faenas pesadas continuas. Robusto, fácil de mantener y con repuestos disponibles de inmediato.'
  },
  {
    id: 'm-apilador-electrico',
    category: 'venta',
    title: 'Apilador Eléctrico Autopropulsado 1.6 Tn',
    badgeText: 'PASILLO ANGOSTO',
    badgeClass: 'badge-bodega',
    highlightTag: '📦 Ideal Racks Altos',
    image: '/images/foto-3.jpg',
    availability: 'Disponible en Stock',
    specs: {
      capacidad: '1,600 kg (1.6 Tn)',
      altura: 'Hasta 4.50 metros',
      motor: 'Tracción AC asistida',
      garantia: '2 Años de Garantía'
    },
    features: [
      'Timón ergonómico multifunción con botón de reversa anti-aplastamiento',
      'Radio de giro ultra compacto para maniobra en pasillos reducidos',
      'Mástil con amortiguación hidráulica para descenso suave de carga',
      'Batería industrial integrada con cargador automático incluido'
    ],
    description: 'Solución logística óptima para almacenamiento vertical en bodegas con pasillos angostos. Máxima maniobrabilidad, ergonomía y seguridad.'
  },

  // --- SECCIÓN: ALQUILER FLEXIBLE ---
  {
    id: 'm-alq-2500',
    category: 'alquiler',
    title: 'Alquiler de Montacargas Eléctricos & Combustión (1.5 - 7.0 Tn)',
    badgeText: 'RENTA EXPRESS',
    badgeClass: 'rent',
    highlightTag: '🛠️ Mantenimiento 100% Incluido',
    image: '/images/foto-6.jpg',
    availability: 'Despacho en 24h',
    specs: {
      capacidad: 'Desde 1.5 Tn hasta 7.0 Tn',
      modalidad: 'Día, Mes o Año',
      mantenimiento: 'Full Cobertura en Sitio',
      reemplazo: 'Respaldo Inmediato en Falla'
    },
    features: [
      'Flota de equipos modernos certificados y listos para operar',
      'Mantenimientos preventivos y correctivos incluidos sin costo extra',
      'Atención técnica prioritaria 24/7 en Bogotá y municipios aledaños',
      'Flexibilidad para escalar o cambiar de equipo según tu demanda logística'
    ],
    description: 'Servicio integral de renta de maquinaria industrial con asistencia técnica total. Reduce costos de inversión y mantén tu operación siempre activa sin paradas.'
  },
  {
    id: 'm-alq-estibadores',
    category: 'alquiler',
    title: 'Alquiler de Transpaletas y Estibadores Eléctricos',
    badgeText: 'LOGÍSTICA CONTINUA',
    badgeClass: 'rent',
    highlightTag: '⚡ Alta Eficiencia',
    image: '/images/foto-1.jpg',
    availability: 'Entrega Inmediata',
    specs: {
      capacidad: '2,000 kg a 2,500 kg',
      modalidad: 'Quincenal / Mensual',
      bateria: 'Baterías de Litio / Gel',
      soporte: 'Asistencia Express'
    },
    features: [
      'Ideal para cargue y descargue rápido en muelles y camiones',
      'Carga de batería estándar a 110V/220V',
      'Cero inversión inicial en compra de maquinaria',
      'Dotación de cargador y capacitación de uso al operador'
    ],
    description: 'Acelera los procesos de recepción y despacho de mercancías con nuestros estibadores eléctricos de alto rendimiento en régimen de arrendamiento.'
  },

  // --- SECCIÓN: MANTENIMIENTO TÉCNICO ---
  {
    id: 'm-mant-preventivo',
    category: 'mantenimiento',
    title: 'Mantenimiento Preventivo & Predictivo Especializado',
    badgeText: 'SERVICIO TÉCNICO',
    badgeClass: 'badge-tech',
    highlightTag: '🔍 Diagnóstico Digital Multimarca',
    image: '/images/foto-2.jpg',
    availability: 'Atención en Planta',
    specs: {
      cobertura: 'Bogotá y Cobertura Nacional',
      tecnicos: 'Especialistas Certificados',
      diagnostico: 'Escáner Multimarca Avanzado',
      reporte: 'Informe Técnico Digital SST'
    },
    features: [
      'Inspección integral de más de 45 puntos críticos de seguridad',
      'Revisión y cambio de fluidos hidráulicos, filtros y engrase de mástil',
      'Diagnóstico computarizado de módulos electrónicos y controladores',
      'Emisión de certificado de operatividad técnica para auditorías'
    ],
    description: 'Evita paradas no programadas y extiende la vida útil de tus montacargas con nuestro programa de mantenimiento preventivo integral ejecutado por ingenieros expertos.'
  },
  {
    id: 'm-mant-correctivo',
    category: 'mantenimiento',
    title: 'Reparación Mayor de Motores, Transmisión & Hidráulica',
    badgeText: 'TALLER ESPECIALIZADO',
    badgeClass: 'badge-tech',
    highlightTag: '⚙️ Banco de Pruebas',
    image: '/images/foto-4.jpg',
    availability: 'Taller & En Sitio',
    specs: {
      servicios: 'Overhaul de Motores y Cajas',
      hidraulica: 'Reparación de Bombas y Pistones',
      garantia: 'Garantía Escrita en Repuestos',
      tiempo: 'Tiempos Récord de Respuesta'
    },
    features: [
      'Reconstrucción total de motores diésel, gasolina y GLP (Toyota, Nissan, Mitsubishi)',
      'Rectificación y sellado de botellas hidráulicas y distribuidores de válvulas',
      'Reparación de transmisiones automáticas y ejes diferenciales de tracción',
      'Pruebas bajo carga dinámica antes de entrega final'
    ],
    description: 'Servicio de reparación correctiva mayor en taller central equipado con maquinaria de precisión y bancos de prueba hidráulica.'
  },

  // --- SECCIÓN: INSUMOS Y REPUESTOS ---
  {
    id: 'r-luces-seguridad',
    category: 'repuestos',
    title: 'Luces de Seguridad Perimetral LED (Blue Spot & Red Zone)',
    badgeText: 'SEGURIDAD VIAL',
    badgeClass: 'parts',
    highlightTag: '🛡️ Prevención de Accidentes',
    image: '/images/forklift-parts.jpg',
    availability: 'Stock Permanente',
    specs: {
      tecnologia: 'LED Ultra Brillante 10-80V',
      patron: 'Punto Azul / Línea Roja Perímetro',
      resistencia: 'IP67 a Prueba de Agua y Polvo',
      vida_util: '+50,000 Horas de Uso'
    },
    features: [
      'Proyección luminosa visible en pisos oscuros e iluminados',
      'Delimita la zona de seguridad obligatoria para peatones en almacén',
      'Compatible con voltajes universales de montacargas (12V, 24V, 48V, 80V)',
      'Instalación rápida en cualquier marca de montacargas'
    ],
    description: 'Accesorios indispensables de seguridad industrial y SST para alertar a los peatones antes de que el montacargas cruce pasillos ciegos o puertas.'
  },
  {
    id: 'r-camaras-monitor',
    category: 'repuestos',
    title: 'Sistemas de Cámaras Inalámbricas con Monitor HD en Cabina',
    badgeText: 'VISIÓN TOTAL',
    badgeClass: 'parts',
    highlightTag: '📹 Precisión en Altura',
    image: '/images/forklift-parts.jpg',
    availability: 'Stock Inmediato',
    specs: {
      pantalla: 'Monitor HD 7" a Color Antirreflejo',
      camara: 'Cámara Inalámbrica con Base Magnética',
      vision: 'Infrarrojo Nocturno Integrado',
      alcance: 'Señal Digital sin Interferencia'
    },
    features: [
      'Permite al operador ver con exactitud las uñas al entrar en estibas altas (+8 metros)',
      'Elimina daños en mercancía por cálculo visual erróneo en racks altos',
      'Cámara resistente a vibraciones industriales intensas e impactos',
      'Alimentación directa por batería con transmisor inalámbrico'
    ],
    description: 'Tecnología de visión en tiempo real para operadores de montacargas y apiladores de gran altura, aumentando la velocidad de estibado y la seguridad.'
  },
  {
    id: 'r-llantas-solidas',
    category: 'repuestos',
    title: 'Llantas Sólidas Antidesgaste & Ruedas de Poliuretano',
    badgeText: 'ORIGINALES',
    badgeClass: 'parts',
    highlightTag: '🚜 Máxima Durabilidad',
    image: '/images/forklift-parts.jpg',
    availability: 'Despacho Directo',
    specs: {
      medidas: '6.50-10, 7.00-12, 18x7-8, 28x9-15',
      material: 'Compuesto de Caucho Natural / PU',
      tipo: 'Sólidas Negras & No Marcantes (Blancas)',
      montaje: 'Servicio de Prensa Hidráulica'
    },
    features: [
      'Compuestos de alta resistencia a cortes por virutas metálicas o estibas rotas',
      'Diseño de banda de rodadura de gran agarre y tracción en piso húmedo',
      'Opciones no marcantes para industria farmacéutica y alimentaria',
      'Disponibilidad de prensa móvil para montaje directo en tus instalaciones'
    ],
    description: 'Ruedas y llantas industriales de alta resistencia diseñadas para soportar trabajo rudo 24/7 sin deformaciones ni desgaste prematuro.'
  },
  {
    id: 'r-baterias-repuestos',
    category: 'repuestos',
    title: 'Baterías Industriales de Litio, Filtros & Componentes Eléctricos',
    badgeText: 'STOCK COMPLETO',
    badgeClass: 'parts',
    highlightTag: '🔌 Repuestos Originales',
    image: '/images/forklift-parts.jpg',
    availability: 'Despacho Nacional',
    specs: {
      marcas: 'Toyota, Hyster, Crown, Yale, Nissan, CAT',
      componentes: 'Contactores, Sensores, Frenos, Mangueras',
      filtros: 'Aire, Aceite, Hidráulico y Combustible',
      garantia: 'Garantía Directa de Importador'
    },
    features: [
      'Repuestos mecánicos, eléctricos e hidráulicos 100% compatibles',
      'Baterías y celdas de tracción de litio con BMS inteligente',
      'Kits de sellos y empaquetaduras para cilindros hidráulicos',
      'Asesoría técnica para ubicar la referencia exacta según número de parte'
    ],
    description: 'Amplio inventario de repuestos y partes para maquinaria industrial con despacho urgente a toda Colombia.'
  }
];
